import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BaseTransaction, Pagination, Response } from '@ui/src';
import { ColumnItems } from '../../../../components/export-column/types';
import { exportPspApi } from '../services';
import { ExportBatchEntity } from '../../types';

export interface ExportBatchesState {
  batches: ColumnItems[];
  batchesPagination?: Pagination;
  panelIsOpen: boolean;
  countNewTransactions: number;
  accountId?: string;
  accountNumber?: string;
  batch?: ExportBatchEntity;
}

const initialState: ExportBatchesState = {
  batches: [],
  panelIsOpen: false,
  countNewTransactions: 0,
  accountId: undefined,
  accountNumber: undefined,
  batch: undefined,
};

export const exportBatchesSlice = createSlice({
  name: 'exportBatches',
  initialState,
  reducers: {
    setNewTransactionCount: (state, action: PayloadAction<number>) => {
      state.countNewTransactions = action.payload;
    },
    setSelectedAccount: (
      state,
      action: PayloadAction<{ accountId: string; accountNumber: string }>,
    ) => {
      state.accountId = action.payload.accountId;
      state.accountNumber = action.payload.accountNumber;
    },
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
    clearExportBatchesState: (state) => {
      state.batch = undefined;
      state.panelIsOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        exportPspApi.endpoints.getExportBatches.matchFulfilled,
        (state, action: PayloadAction<Response<ExportBatchEntity>>) => {
          state.batches = action.payload.data.edges.map((item) => ({
            id: item.node.id,
            name: item.node.number,
            date: item.node.createdAt,
          }));

          state.batchesPagination = action.payload.data.pageInfo;
        },
      )
      .addMatcher(
        exportPspApi.endpoints.getExportOutgoingTransactionsCount
          .matchFulfilled,
        (state, action: PayloadAction<Response<BaseTransaction>>) => {
          state.countNewTransactions = action.payload.data.pageInfo.totalCount;
        },
      )
      .addMatcher(
        exportPspApi.endpoints.getExportBatchById.matchFulfilled,
        (state, action: PayloadAction<{ data: ExportBatchEntity }>) => {
          state.batch = action.payload.data;
        },
      );
  },
});

export const {
  setSelectedAccount,
  changePanelState,
  clearExportBatchesState,
  setNewTransactionCount,
} = exportBatchesSlice.actions;

export default exportBatchesSlice.reducer;
